import { render } from "./EditContract.vue?vue&type=template&id=caf08918"
import script from "./EditContract.vue?vue&type=script&lang=js"
export * from "./EditContract.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__